import '@akpl/ui-tv/styles.css';

import { reloadOnStaleChunk } from '@akpl/shared';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';

// A page left open across a deploy asks for files that no longer exist: reload instead of dying.
reloadOnStaleChunk();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
